import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from "@material-ui/core";
import dayjs from "dayjs";
import { Autocomplete } from "@material-ui/lab";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";
import KPTimePicker from "../../../components/KPTimePicker";
import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";
import DuplicateCheckModal from "../../../components/Solution/DuplicateCheckModal";

import { uploadMultiFile } from "../../../reducer/file/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { insertSolution, updateSolution, checkDuplicateSolution } from "../../../reducer/solution/action";
import { getAllEmploymentContractByProfileId } from "../../../reducer/employmentContract/action";
import { notification } from "../../../reducer/home/action";
import { KPTextfield } from "components/KPTComponents";
import { getCurrentSchoolYear } from "containers/User/TimeResearch/utils";

function SolutionInsertModal(props) {
  const { inserting, setInserting } = props;

  const [newFiles, setNewFiles] = useState([]);
  const [detail, setDetail] = useState(null);
  const [profileList, setProfileList] = useState([]);
  const currentYear = getCurrentSchoolYear();
  const [values, setValues] = useState({
    purposeId: 5,
    issueAt: `01/01/${currentYear}`,
    acceptedDay: `01/01/${currentYear}`,
    submissionDay: `01/01/${currentYear}`,
    departmentId: props.profileDepartments?.[0]?.id || null,
  });
  const [timeResearchYear, setTimeResearchYear] = useState(currentYear);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [duplicateList, setDuplicateList] = useState([]);
  const [pendingSubmit, setPendingSubmit] = useState(false);

  // Tự gán bản thân vào danh sách tác giả
  useEffect(() => {
    if (props.profile?.id && profileList.length === 0) {
      setProfileList([
        {
          profileId: props.profile.id,
          roleInSolution: "main",
          isInternal: true,
          externalName: "",
        },
      ]);
    }
  }, [inserting, props.profile?.id]);

  // Bỏ KPI bỏ luôn contract
  // useEffect(() => {
  //   if (!values?.profileIdForKpi) handleChangeForm("contractIdForKpi", null);
  // }, [values?.profileIdForKpi]);

  const dateFormat = (value) => {
    const dateForm = value?.replaceAll("/", "");
    const date = dateForm?.substr(0, 2);
    const month = dateForm?.substr(2, 2);
    const year = dateForm?.substr(-4);
    return value ? dayjs(`${month}/${date}/${year}`).format("YYYY-MM-DDTHH:mm:ssZ") : null;
  };

  const handleChangeForm = (name, value) => {
    setValues({ ...values, [name]: value });
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    }
    if (name === "purposeId") {
      setValues({
        ...values,
        purposeId: value,
        profileIdForKpi: null,
        contractIdForKpi: null,
      });
    }
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInSolution: "main",
      isInternal: true,
      externalName: "",
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    if (profileList[index].profileId === values?.profileIdForKpi) handleChangeForm("profileIdForKpi", null);

    const temp = profileList.filter((e, id) => id !== index);
    setProfileList([...temp]);
  };

  const checkForDuplicates = async () => {
    if (!values?.title) {
      return false;
    }

    const checkResult = await props.checkDuplicateSolution({
      publicationType: "solutions",
      title: values.title,
    });

    if (checkResult.error) {
      return "error";
    }

    if (checkResult.success && checkResult.data && checkResult.data.length > 0) {
      setDuplicateList(checkResult.data);
      setDuplicateModalOpen(true);
      return true;
    }

    return false;
  };

  const handleSelectDuplicate = (duplicate) => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);

    // Reset Insert modal
    setInserting(false);
    setValues(null);
    setProfileList([]);
    setNewFiles([]);

    // Trigger Update modal with _fromDuplicate flag
    const solutionData = {
      ...duplicate.solution,
      _fromDuplicate: true,
    };

    // Add current user to profileList if not already present
    const existingProfiles = duplicate.solutionProfile || [];
    const currentUserExists = existingProfiles.some((p) => p.profileId === props.profile?.id);

    if (!currentUserExists) {
      solutionData.solutionProfile = [
        ...existingProfiles,
        {
          profileId: props.profile.id,
          roleInSolution: "main",
          isInternal: true,
          externalName: "",
        },
      ];
    }

    props.setUpdating(solutionData);
  };

  const handleCloseDuplicateModal = () => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(false);
  };

  const handleSubmit = async (e) => {
    // check title, numOfOwner, numOfMember
    if (!values?.title) {
      setHelperText(true);
      return;
    }
    if (!values?.numOfOwner) {
      setHelperText(true);
      return;
    }
    if (!values?.numOfMember) {
      setHelperText(true);
      return;
    }

    // Validate at least one internal member
    const hasInternalMember = profileList.some((e) => e.isInternal === true);
    if (!hasInternalMember) {
      props.pushNoti({
        type: "warning",
        message: "Phải có ít nhất 1 thành viên nội bộ của trường trong công trình khoa học!",
      });
      return;
    }

    // Check for duplicates first
    if (!pendingSubmit) {
      const duplicateCheck = await checkForDuplicates();
      if (duplicateCheck === "error") {
        return;
      }
      if (duplicateCheck === true) {
        setPendingSubmit(true);
        return;
      }
    }

    setPendingSubmit(false);
    setInserting(false);
    const d = new Date();

    props
      .insertSolution(props.profile?.id, {
        ...values,
        dashboardYear: new Date(dateFormat(values?.acceptedDay || moment().format("YYYY-MM-DD"))).getFullYear(),
        solutionProfile: profileList,
        issueAt: dateFormat(values?.issueAt),
        acceptedDay: dateFormat(values?.acceptedDay),
        submissionDay: dateFormat(values?.submissionDay),
      })
      .then(async (response) => {
        if (response.success && newFiles.length > 0) {
          const uploadResult = await props.uploadMultiFile(response.data.id, newFiles, "solution");
          if (uploadResult.success) {
            props.updateSolution(response.data.id, {
              ...response.data,
              fileUrl: uploadResult.data.join("||"),
            });
          }
        }
        props.statisticUnaccepted({
          departmentId: 0,
          profileId: props.profile?.id,
        });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      })
      .catch();
    setValues(null);
    setProfileList([]);
  };

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  const profileListFromProps = [{ id: -1, name: "" }];
  props.profileList.forEach((e) => profileListFromProps.push(e));

  // var timeResearchDetailList =
  //   props.timeResearchInformationList?.find((e) => e.year === 0)
  //     ?.timeResearchDetail || [];
  // timeResearchDetailList = timeResearchDetailList.filter(
  //   (e) => !e.allowedUpdateNum && e.type?.includes("solution")
  // );

  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0 && timeResearchYear) {
      let list = props.timeResearchInformationList
        ?.find((e) => e.year === 0)
        ?.timeResearchDetail.filter((e) => !e.allowedUpdateNum && e.type?.includes("solution"));
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
        timeResearchDetailCode: null,
      });
    }
  }, [props.timeResearchInformationList, timeResearchYear]);

  const yearList = [];
  props.timeResearchInformationList
    .sort((a, b) => b.year - a.year)
    .forEach((e) => {
      yearList.push(e.year);
    });

  const handleCloseInsertModal = () => {
    setInserting(false);
    setValues(null);
    setProfileList([]);
    setNewFiles([]);
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(false);
  };

  return (
    <>
      <Dialog
        fullWidth
        maxWidth={values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "xl" : "lg"}
        open={inserting}
        onClose={handleCloseInsertModal}
        disableBackdropClick
      >
        <DialogTitle>Thêm giải pháp hữu ích</DialogTitle>
        <DialogContent style={{ display: "flex", gap: 16, overflowX: "hidden" }}>
          <div
            style={{
              display: "flex",
              flex: "1 1 auto",
              minWidth: 0,
              paddingRight: 16,
            }}
          >
            <Grid container spacing={2} style={{ marginBottom: 10 }}>
              <Grid item xs={7}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Tên giải pháp"
                  value={values?.title || ""}
                  required
                  error={helperText && !values?.title}
                  helperText={helperText && !values?.title ? "Tên giải pháp không được để trống" : ""}
                  onChange={(event) => handleChangeForm("title", event.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Mã CTKH"
                  value={values?.hemisCode || ""}
                  onChange={(event) => handleChangeForm("hemisCode", event.target.value)}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  required
                  fullWidth
                  size="small"
                  type="number"
                  variant="outlined"
                  label="Số lượng đồng sở hữu"
                  value={values?.numOfOwner || ""}
                  error={helperText && !values?.numOfOwner}
                  helperText={helperText && !values?.numOfOwner ? "Số lượng đồng sở hữu không được để trống" : ""}
                  onChange={(event) => handleChangeForm("numOfOwner", parseInt(event.target.value))}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  fullWidth
                  size="small"
                  options={(props.departmentList || []).filter((d) => d.id !== 0)}
                  getOptionLabel={(option) => option?.name || ""}
                  value={
                    (props.departmentList || []).filter((d) => d.id !== 0).find((d) => d.id === values?.departmentId) ||
                    null
                  }
                  onChange={(event, newValue) => handleChangeForm("departmentId", newValue?.id || null)}
                  renderInput={(params) => <TextField {...params} size="small" label="Đơn vị" variant="outlined" />}
                />
              </Grid>
              <Grid item xs={12}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        values={values?.isPhenikaa}
                        onChange={(event) => {
                          handleChangeForm("isPhenikaa", event.target.checked);
                        }}
                      />
                    }
                    label="Trường Đại học CMC là Cơ quan chủ trì"
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  rows={2}
                  fullWidth
                  multiline
                  size="small"
                  variant="outlined"
                  label="Nhóm tác giả"
                  value={values?.authorTeam || ""}
                  onChange={(event) => handleChangeForm("authorTeam", event.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  size="small"
                  type="number"
                  variant="outlined"
                  label="Số lượng thành viên tham gia"
                  value={values?.numOfMember || ""}
                  error={helperText && !values?.numOfMember}
                  helperText={
                    helperText && !values?.numOfMember ? "Số lượng thành viên tham gia không được để trống" : ""
                  }
                  onChange={(event) => handleChangeForm("numOfMember", parseInt(event.target.value))}
                />
              </Grid>
              <Grid item xs={6}>
                <KPTimePicker
                  fullWidth
                  label="Ngày cấp bằng"
                  value={values?.issueAt || "dd/mm/yyyy"}
                  setValue={(newValue) => handleChangeForm("issueAt", newValue)}
                />
                {/* <TextField
                fullWidth
                size='small'
                type='date'
                variant='outlined'
                label='Ngày cấp bằng'
                value={values?.issueAt || 0}
                InputLabelProps={{ shrink: true }}
                onChange={(event) => handleChangeForm('issueAt', event.target.value)}
              /> */}
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Cơ sở cấp"
                  variant="outlined"
                  value={values?.issueBy || ""}
                  onChange={(event) => handleChangeForm("issueBy", event.target.value)}
                />
              </Grid>
              <Grid item xs={4}>
                <KPTimePicker
                  fullWidth
                  label="Ngày nộp đơn"
                  value={values?.submissionDay || "dd/mm/yyyy"}
                  setValue={(newValue) => handleChangeForm("submissionDay", newValue)}
                />
                {/* <KPTextfield
                id="submissionDay"
                type="date"
                // disabled={disabled && props.id !== "edit-basic"}
                value={values?.submissionDay}
                label="Ngày nộp đơn"
                variant="outlined"
                handleChangeForm={handleChangeForm}
                // required={true}
              /> */}
              </Grid>
              <Grid item xs={4}>
                <KPTimePicker
                  fullWidth
                  label="Ngày chấp nhận đơn"
                  value={values?.acceptedDay || "dd/mm/yyyy"}
                  setValue={(newValue) => handleChangeForm("acceptedDay", newValue)}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  size="small"
                  label="Số (Identification number)"
                  variant="outlined"
                  value={values?.identificationNumber || ""}
                  onChange={(event) => handleChangeForm("identificationNumber", event.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Số lượng trang"
                  variant="outlined"
                  value={values?.pageNumber || ""}
                  onChange={(event) => handleChangeForm("pageNumber", parseInt(event.target.value))}
                />
              </Grid>
              {/* <Grid item xs={3}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label="Điểm GS-PGS"
                variant="outlined"
                value={values?.score?.toString() || ""}
                onChange={(event) => handleChangeForm("score", parseFloat(event.target.value))}
              />
            </Grid> */}
              <Grid item xs={6}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                    Mục đích
                  </InputLabel>
                  <Select
                    native
                    fullWidth
                    labelId="purpose-label"
                    value={values?.purposeId ?? "none"}
                    onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
                  >
                    {props.purposes
                      .filter((e) => e.name !== "bonusCalculated")
                      .map((e) => (
                        <option key={e.id} value={e.id}>
                          {e.description}
                        </option>
                      ))}
                  </Select>
                </FormControl>
              </Grid>

              {values?.purposeId === 5 && (
                <>
                  {/* <Grid item xs={3}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      value={timeResearchYear}
                      SelectProps={{ native: true }}
                      label="Năm học tính giờ nghiên cứu"
                      variant="outlined"
                      onChange={(event) => {
                        setTimeResearchYear(parseInt(event.target.value));
                        handleChangeForm("timeResearchDetailCode", null);
                      }}
                    >
                      {yearList.map((e) => (
                        <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                          {e} - {e + 1}
                        </option>
                      ))}
                    </TextField>
                  </Grid> */}
                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Nhiệm vụ tính giờ nghiên cứu"
                      variant="outlined"
                      value={values?.timeResearchDetailCode || null}
                      onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                      InputLabelProps={{
                        shrink: !(
                          values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                        ),
                      }}
                      error={!values?.timeResearchDetailCode}
                    >
                      {timeResearchDetailList.length > 0 ? (
                        timeResearchDetailList?.map((e) => (
                          <MenuItem key={e.code} value={e.code}>{`${e.description} - ${e.value}(h)`}</MenuItem>
                        ))
                      ) : (
                        <MenuItem value={null}>Chưa có dữ liệu</MenuItem>
                      )}
                    </TextField>
                    {!values?.timeResearchDetailCode && <FormHelperText error>Phải chọn một nhiệm vụ!</FormHelperText>}
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Ghi chú"
                  variant="outlined"
                  value={values?.note || ""}
                  multiline
                  rows={3}
                  onChange={(event) => handleChangeForm("note", event.target.value)}
                />
              </Grid>

              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values?.isOvertimeCountable || false}
                      disabled={props.role !== "sudo-admin"}
                      onChange={(event) => handleChangeForm("isOvertimeCountable", event.target.checked)}
                      color="primary"
                    />
                  }
                  label="Tính giờ ngoài quy chế"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="Số giờ ngoài quy chế"
                  variant="outlined"
                  value={values?.overtimeHours ?? ""}
                  disabled={props.role !== "sudo-admin" || !values?.isOvertimeCountable}
                  onChange={(event) => handleChangeForm("overtimeHours", parseFloat(event.target.value) || 0)}
                  inputProps={{
                    min: 0,
                    step: 0.1,
                  }}
                />
              </Grid>

              <Grid item xs={5} style={{ margin: "auto" }}>
                <Divider />{" "}
              </Grid>
              <Grid item xs={2}>
                <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
              </Grid>
              <Grid item xs={5} style={{ margin: "auto" }}>
                <Divider />{" "}
              </Grid>

              <Grid item xs={12}>
                {profileList.map((e, index) => (
                  <Grid key={`list-${index}`} container spacing={2}>
                    <Grid item xs={1}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={e.isInternal !== false}
                            onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                            color="primary"
                          />
                        }
                        label="Nội bộ"
                      />
                    </Grid>
                    {e.isInternal && (
                      <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 8 : 6}>
                        <Autocomplete
                          disableClearable
                          options={profileListFromProps}
                          getOptionLabel={(option) => option.name}
                          value={
                            profileListFromProps?.find((profile) => profile.id === e.profileId) ||
                            profileListFromProps[0]
                          }
                          onChange={(event, profile) => {
                            if (profileList[index]?.profileId === values?.profileIdForKpi)
                              handleChangeForm("profileIdForKpi", null);
                            handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                          }}
                          renderInput={(params) => (
                            <TextField {...params} size="small" label="Thành viên" variant="outlined" />
                          )}
                        />
                      </Grid>
                    )}
                    {!e.isInternal && (
                      <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 8 : 6}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          label="Tên thành viên"
                          value={e?.externalName || ""}
                          onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                        />
                        {helperText && e.externalName === "" && (
                          <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                        )}
                      </Grid>
                    )}
                    {values?.purposeId === 1 && (
                      <Grid item xs={3}>
                        <FormControl required fullWidth error={!values?.profileIdForKpi}>
                          <Button
                            fullWidth
                            color="primary"
                            variant="outlined"
                            style={{ height: 40 }}
                            disabled={e.profileId === null}
                            startIcon={
                              typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                                <CheckBox />
                              ) : (
                                <CheckBoxOutlineBlank />
                              )
                            }
                            onClick={() => {
                              setDetail(null);
                              props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                              handleChangeForm(
                                "profileIdForKpi",
                                values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                              );
                            }}
                          >
                            Tính KPI
                          </Button>
                          {!values?.profileIdForKpi && <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>}
                        </FormControl>
                      </Grid>
                    )}
                    {values?.purposeId === 99999999 && (
                      <Grid item xs={3}>
                        <FormControl required fullWidth error={!values?.profileIdForReward}>
                          <Button
                            fullWidth
                            color="primary"
                            variant="outlined"
                            style={{ height: 40 }}
                            disabled={e.profileId === null}
                            startIcon={
                              typeof values?.profileIdForReward === "number" &&
                              values?.profileIdForReward === e.profileId ? (
                                <CheckBox />
                              ) : (
                                <CheckBoxOutlineBlank />
                              )
                            }
                            onClick={() => {
                              setDetail(null);
                              handleChangeForm(
                                "profileIdForReward",
                                values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                              );
                            }}
                          >
                            Tính thưởng
                          </Button>
                          {!values?.profileIdForReward && (
                            <FormHelperText>Phải chọn 1 người tính thưởng</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                    )}
                    <Grid item xs={3}>
                      <Button
                        fullWidth
                        color="secondary"
                        variant="contained"
                        style={{ height: 40 }}
                        onClick={() => handleRemove(index)}
                      >
                        Xoá
                      </Button>
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              <Grid item xs={12}>
                <Button fullWidth variant="outlined" onClick={handleInsert}>
                  Thêm thành viên
                </Button>
              </Grid>
            </Grid>
          </div>
          <div
            style={{
              flexDirection: "column",
              display: values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "block" : "none",
            }}
          >
            <EmploymentContractTable
              contract={detail}
              contractList={contractList}
              kpiIdForKpi={values?.kpiIdForKpi}
              contractIdForKpi={values?.contractIdForKpi}
              setDetail={setDetail}
              values={values}
              setValues={setValues}
              handleChangeForm={handleChangeForm}
            />
            <EmploymentContractDetailTable kpi={detail} />
          </div>
          <div style={{ flex: "0 0 380px", paddingLeft: 16, borderLeft: "1px solid #e0e0e0" }}>
            <Typography variant="subtitle1" style={{ marginBottom: 8, fontWeight: 600 }}>
              File minh chứng
            </Typography>
            <MultiFileManager fileUrls={[]} setFileUrls={() => {}} newFiles={newFiles} setNewFiles={setNewFiles} />
          </div>
        </DialogContent>
        <DialogActions style={{ padding: "0 24px 8px 24px" }}>
          <Grid container justifyContent={"space-between"}>
            <div />
            <div style={{ float: "right" }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setInserting(false)}
                style={{ marginRight: 4 }}
              >
                Huỷ
              </Button>
              {/* <Button variant="contained" color="primary" onClick={() => handleSubmit()}>Xác nhận</Button> */}
              <Button
                variant="contained"
                color="primary"
                disabled={
                  (values?.purposeId === 1 && !(values?.profileIdForKpi && values?.contractIdForKpi)) ||
                  (values?.purposeId === 99999999 && !values?.profileIdForReward) ||
                  (values?.purposeId === 5 && !values?.timeResearchDetailCode)
                }
                onClick={() => handleSubmit()}
              >
                Xác nhận
              </Button>
            </div>
          </Grid>
        </DialogActions>
        <DuplicateCheckModal
          open={duplicateModalOpen}
          duplicates={duplicateList}
          onClose={handleCloseDuplicateModal}
          onSelectDuplicate={handleSelectDuplicate}
        />
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  profileDepartments: select(state, "profileReducer", "departments"),
  departmentList: select(state, "departmentReducer", "departments"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  yearFilter: select(state, "timeResearchInformationReducer", "yearFilter"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  isFetchingTimeResearchInformation: select(state, "timeResearchInformationReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  uploadMultiFile: (id, files, type) => dispatch(uploadMultiFile(id, files, type)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  insertSolution: (profileId, payload) => dispatch(insertSolution(profileId, payload)),
  updateSolution: (profileId, payload) => dispatch(updateSolution(profileId, payload)),
  checkDuplicateSolution: (payload) => dispatch(checkDuplicateSolution(payload)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
  pushNoti: (payload) => dispatch(notification(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(SolutionInsertModal));

